"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDictionary = void 0;
const i18n_1 = require("@pulse-web-platform-core/i18n");
const react_1 = require("react");
const useDictionary = (resTexts, isLoadingTexts) => {
    (0, react_1.useEffect)(() => {
        var _a;
        if (resTexts && (resTexts === null || resTexts === void 0 ? void 0 : resTexts.ru) && !isLoadingTexts) {
            (_a = Object.keys(resTexts.ru)) === null || _a === void 0 ? void 0 : _a.forEach((item) => {
                if (resTexts.ru[item]) {
                    i18n_1.i18n.addResourceBundle('ru', item, resTexts.ru[item], true, true);
                }
            });
        }
    }, [resTexts, isLoadingTexts]);
};
exports.useDictionary = useDictionary;
